import React, { HTMLAttributes } from 'react'
import { styles } from './Manifesto.css'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { Tag } from '@otomoro/components/shared/Tag'
import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { AppText } from '@otomoro/components/shared/AppText'
import { PortableTextObject } from 'sanity'
import { ReChemistry } from '@otomoro/components/icons/ReChemistry'

interface ManifestoProps extends HTMLAttributes<Element> {
	tag: string
	headline: PortableTextObject
	showLogo: boolean
	leftContent: PortableTextObject
	rightContent: PortableTextObject
}

export const Manifesto: React.FC<ManifestoProps> = ({ tag, headline, showLogo, leftContent, rightContent }) => {
	const { base, tagText, contentWrapper, content } = styles()

	const titleComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle
					as="h2"
					variant="h1"
					textTransform="uppercase"
					className="mt-[0.5rem]"
					color="black"
				>
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	const contentComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" size="base" className='h-fit max-w-[60ch]'>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<section className={base()}>
			<header>
				<Tag as="strong" className={tagText()}>
					{tag}
				</Tag>
				{showLogo && <ReChemistry className="mt-[1.3rem] w-[26.5rem] md:w-[28rem]" theme="dark" />}
				<PortableText value={headline} components={titleComponents} />
			</header>
			<div className={contentWrapper()}>
				{leftContent &&
					<div className={content()}>
						<PortableText value={leftContent} components={contentComponents} />
					</div>
				}
				{rightContent &&
					<div className={content()}>
						<PortableText value={rightContent} components={contentComponents} />
					</div>
				}
			</div>
		</section>
	)
}
